'use strict';

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./cjs/react.production.min.js');
} else {
  module.exports = require('./cjs/react.development.js');
}



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-telegram-embed/~/react/index.js
 ** module id = 3564
 ** module chunks = 0
 **/